
(function () {
  'use strict';
  function trackEmailSubmission(statusString) {
    var lang = (document.documentElement.lang || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'landing_email_submission_click',
        'status': statusString, 
        'pageLanguage': lang
    });
  }

  document.addEventListener('click', function (e) {
    var target = e.target.closest('[data-jora-scroll]');
    if (!target) return;
    var id = target.getAttribute('data-jora-scroll') || target.getAttribute('href').replace(/^#/, '');
    var el = document.getElementById(id);
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, false);


  document.addEventListener('DOMContentLoaded', function() {
    const bookDemoForm = document.getElementById('jora-book-demo');
    if (!bookDemoForm) return;

    bookDemoForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      const form = e.target;
      const container = document.getElementById('jora-book-form-container');
      const endpoint = container?.dataset.leadEndpoint;
      const calendlyUrl = container?.dataset.calendlyUrl;
      const formData = {
        name: form.querySelector('[name="contact[name]"]')?.value,
        email: form.querySelector('[name="contact[email]"]')?.value,
        url: form.querySelector('[name="contact[store_url]"]')?.value,
        need: form.querySelector('[name="contact[body]"]')?.value
      };

      try {
        await fetch(endpoint, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        });

        form.style.display = 'none'; 
        
        if (typeof Calendly !== 'undefined' && calendlyUrl && calendlyUrl.trim() !== "") {
            const isMobile = window.innerWidth <= 720;
            
            if (isMobile) {
                Calendly.showPopupWidget(calendlyUrl, "Book your demo", {
                    prefill: {
                        name: formData.name,
                        email: formData.email
                    }
                });
            } else {
                const parent = document.getElementById('jora-cal-inline');
                parent.innerHTML = ''; 
                Calendly.initInlineWidget({
                    url: calendlyUrl,
                    parentElement: parent,
                    prefill: {
                        name: formData.name,
                        email: formData.email
                    }
                });
            }
        }
      } catch (err) {
        console.error("Submission error:", err);
        alert("Something went wrong. Please try again.");
      }
    });
  });

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  if (!prefersReduced) {
    root.classList.add('motion-hero', 'motion-reveal', 'motion-mock');
  }

  if ('IntersectionObserver' in window && !prefersReduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.mvp-reveal').forEach(function (el) {
      io.observe(el);
    });
  } else {
    document.querySelectorAll('.mvp-reveal').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

   function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());
  }
  
  document.querySelectorAll('[data-jora-notify]').forEach(function (form) {
    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button[type="submit"]');
    var hint = form.querySelector('#email-hint');
    var check = form.querySelector('#email-check');

    function refreshStates() {
      var val = input.value.trim();
      var valid = isValidEmail(val);

      btn.disabled = (val === '');

      if (val !== '' && !valid) {
        if (hint) hint.hidden = false;
        if (check) check.hidden = true;
        form.classList.add('err');
      } else {
        if (hint) hint.hidden = true;
        if (check) check.hidden = !valid;
        form.classList.remove('err');
      }
    }

    input.addEventListener('input', refreshStates);
    input.addEventListener('blur', refreshStates);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();

      if (!isValidEmail(email)) {
        refreshStates();
        input.focus();
        return;
      }

      btn.disabled = true;
      var orig = btn.innerHTML;
      btn.innerHTML = '<span style="white-space:nowrap">…</span>';

      var uId = form.dataset.mailchimpU;
      var listId = form.dataset.mailchimpId;

      if (!uId || !listId) {
        console.error("Mailchimp Configuration Error: Missing u or id from section settings.");
        btn.disabled = false;
        btn.innerHTML = orig;
        return;
      }

      var selectedListId = listId;

      var mailchimpUrl = 'https://joraleka.us5.list-manage.com/subscribe/post-json?u=' + uId + '&id=' + selectedListId;

      $.ajax({
        url: mailchimpUrl,
        type: 'GET',
        data: { 'EMAIL': email },
        dataType: 'jsonp',
        jsonp: 'c',
        success: function (data) {
          var isSuccess = data.result === 'success';
          var isAlreadyRegistered = data.msg && (
            data.msg.includes('déjà inscrit') ||
            data.msg.toLowerCase().includes('already subscribed')
          );

          if (isSuccess || isAlreadyRegistered) {
            trackEmailSubmission('landing_email_submission_success');
            swapToDoneState(form, isAlreadyRegistered ? 'already' : 'success');
          } else {
            trackEmailSubmission('landing_email_submission_error');
            console.error("Mailchimp error:", data.msg);
            form.classList.add('err');
            if (btn) { btn.disabled = false; btn.innerHTML = orig; }
          }
        },
        error: function () {
          trackEmailSubmission('landing_email_submission_error');
          swapToDoneState(form, 'error');
        }
      });
    });
  });

 // Update the function to accept a status type
function swapToDoneState(form, status = 'success') {
  var lang = (document.documentElement.lang || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en';
  
  // Define messages based on status
  var messages = {
    'success': (lang === 'fr' ? "C'est noté, on vous écrit au lancement." : "Got it, we'll email you at launch."),
    'already': (lang === 'fr' ? "Vous êtes déjà inscrit" : "You are already registered."),
    'error': (lang === 'fr' ? "Adresse e-mail invalide." : "Invalid email address.")
  };

  var message = messages[status] || messages['error'];

  // Define icons
  var successIcon = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7.5l3 3 7-7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var errorIcon = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="2"/><path d="M7 4v4M7 10h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  var container = document.createElement('div');
  // Use a class to handle the color in your CSS
  container.className = 'mvp-notify ' + (status === 'success' ? 'mvp-notify-done' : 'mvp-notify-error');
  container.setAttribute('role', 'status');
  
  container.innerHTML = '<span class="mvp-notify-icon">' + (status === 'success' ? successIcon : errorIcon) + '</span>' +
                        '<span>' + message + '</span>';
  
  form.replaceWith(container);
}
 
document.addEventListener('DOMContentLoaded', () => {
  const source = document.querySelector('.language_switcher');
  const target = document.querySelector('.lang-toggle-wrapper');

  if (source && target) {
    target.appendChild(source);
  }
});

})();